import { EventsFlatDTO } from "../domain/models/dto/EventsDTO";
import { IEventFlat } from "../domain/models/Events";
import { EventsFlatModel } from "../models/EventsFlatModel";
import { FileMapper } from "./FileMapper";
import { SimpleMapper } from "./SimpleMapper";

export class EventsFlatMapper extends SimpleMapper<IEventFlat, EventsFlatDTO> {
    protected toDTOFields: string[] = [
        "id",
        "title",
        "subtitle",
        "description",
        "languageCode",
        "files",
        "eventDate",
        "location",
        "format",
    ];

    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "createdAt",
        "updatedAt",
        "creatorId",
    ];

    protected entityConstructor = EventsFlatModel;

    private fileMapper = new FileMapper();

    fromDTO(dto: EventsFlatDTO): IEventFlat {
        if (!dto) return null;

        const baseModel = super.fromDTO(dto);
        baseModel.description = dto.description ?? "";
        baseModel.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];
        if (dto.eventDate) {
            baseModel.eventDate = dto.eventDate instanceof Date
                ? dto.eventDate
                : new Date(dto.eventDate);
        }

        return baseModel;
    }

    toDTO(model: IEventFlat): EventsFlatDTO {
        if (!model) return null;

        const baseDto = super.toDTO(model);
        baseDto.description = model.description ?? null;
        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];

        return baseDto;
    }
}

